import { render, staticRenderFns } from "./CommentsDrawer.vue?vue&type=template&id=a4ce2ed0&scoped=true&"
import script from "./CommentsDrawer.vue?vue&type=script&lang=ts&"
export * from "./CommentsDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsDrawer.vue?vue&type=style&index=0&id=a4ce2ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ce2ed0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VDivider,VIcon,VNavigationDrawer,VRow,VScrollYTransition,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4ce2ed0')) {
      api.createRecord('a4ce2ed0', component.options)
    } else {
      api.reload('a4ce2ed0', component.options)
    }
    module.hot.accept("./CommentsDrawer.vue?vue&type=template&id=a4ce2ed0&scoped=true&", function () {
      api.rerender('a4ce2ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tickets/comments/CommentsDrawer.vue"
export default component.exports